import { Box, type BoxProps } from "@chakra-ui/react"
import { useLayoutEffect, useRef } from "react"

import { decorateByOffsets } from "./domAnnotations"
import type { AnnotationRange } from "./textAnnotations"

export function AnnotatableContainer({
  blockId,
  ranges,
  contentKey,
  ...props
}: {
  blockId: string
  ranges: AnnotationRange[]
  contentKey?: string | number
} & Omit<BoxProps, "ref">) {
  const ref = useRef<HTMLElement | null>(null)

  useLayoutEffect(() => {
    void contentKey
    const el = ref.current
    if (!el) return
    decorateByOffsets({ root: el, ranges })
  }, [ranges, contentKey])

  return (
    <Box
      ref={ref}
      data-quiz-annotatable="true"
      data-quiz-annotation-block-id={blockId}
      {...props}
    />
  )
}
